export default __webpack_public_path__ + "static/media/gluten-free.60e2a107.svg";